export enum LoginOption {
  Local = "local",
  Ldap = "ldap",
  LdapWithQuery = "ldapwithquery"
}